import React from 'react';
import { connect } from 'react-redux';

import MapComponent from 'components/Shared/Map/Map';
import GoogleMapsLoader from 'components/Shared/Map/GoogleMapsLoader';
import { updateMapType } from 'store/actions/map';
import { getEffectiveTheme } from 'helpers/themeHelper';

var Map = function(props) {
  var effectiveTheme = getEffectiveTheme(props.themeMode || 'system');
  return (
    <GoogleMapsLoader>
      <MapComponent key={'map-' + effectiveTheme} {...props} />
    </GoogleMapsLoader>
  );
};

var mapStateToProps = function(state) {
  return {
    mapType: state.app.mapType,
    themeMode: state.app.themeMode,
  };
};

export default connect(mapStateToProps, { updateMapType })(Map);
